import { Component, OnInit } from '@angular/core';
import { AlertService } from 'src/app/core/services/alert.service';
import { AnnouncementService } from 'src/app/core/services/announcement.service';
import { LoadingService } from 'src/app/core/services/loading.service';

@Component({
  selector: 'app-my-announcements',
  templateUrl: './my-announcements.component.html',
  styleUrls: ['./my-announcements.component.scss']
})
export class MyAnnouncementsComponent implements OnInit {
  announcementList = [];

  constructor(private alertService: AlertService,
    private loadingService: LoadingService,
    private announcementService: AnnouncementService) { }

  ngOnInit(): void {
    this.getAnnouncementList();
  }

  getAnnouncementList(){
    this.loadingService.setLoading(true);
    this.announcementService.getMyAnnouncements().subscribe(response => {
      if (response.success) {
        console.log(this.announcementList)
        this.announcementList = response.announcements;
       
        this.loadingService.setLoading(false);
      }
    },
    (error) => {
      this.loadingService.setLoading(false);
      this.alertService.alert('Hata!', error.error.Message, 'error');
      console.log('Error --->:', error);
    });
  }
}
